// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import WebWidgetApp from './app/WebWidgetApp.vue'
import router from './webWidgetRouter'
import store from './webWidgetStore'
import jQuery from 'jquery'
import Notifications from 'vue-notification'
import linkify from 'vue-linkify'
import vSelect from 'vue-select'
import 'document-register-element/build/document-register-element'
import VueCustomElement from 'vue-custom-element'

if (!window.jQuery) {
  window.jQuery = jQuery
}

if (!window.$) {
  window.$ = jQuery
}

Vue.use(BootstrapVue)
Vue.use(Notifications)
Vue.use(VueCustomElement)

Vue.component('v-select', vSelect)
Vue.directive('linkified', linkify)

WebWidgetApp.store = store
WebWidgetApp.router = router
Vue.customElement('pragya-widget', WebWidgetApp)



// WEBPACK FOOTER //
// ./widgetSrc/webWidgetMain.js